(function () {
  'use strict';

  if (window.koszChatGuard) return;
  window.koszChatGuard = true;

  var html = document.documentElement;
  var SHOW_DELAY = 240;
  var HTML_SIGNALS = ['js-drawer-open', 'modal-open', 'modal-closing', 'kosz-open', 'kosz-closing'];
  var BODY_SIGNALS = ['aio-panel-open', 'predictive-overflow-hidden'];
  var hidden = false;
  var showTimer = null;
  var watchedChat = null;

  function hasAny(el, list) {
    if (!el) return false;
    for (var i = 0; i < list.length; i++) {
      if (el.classList.contains(list[i])) return true;
    }
    return false;
  }

  function busy() {
    if (html.classList.contains('kosz-chat')) return false;
    if (hasAny(html, HTML_SIGNALS) || hasAny(document.body, BODY_SIGNALS)) return true;
    return !!document.querySelector('dialog[open], .pswp--open');
  }

  function apply(chat, hide) {
    if (hide) {
      chat.style.setProperty('visibility', 'hidden');
      chat.style.setProperty('--shopify-chat-z-index', '1');
    } else {
      chat.style.removeProperty('visibility');
      chat.style.removeProperty('--shopify-chat-z-index');
    }
  }

  function update() {
    var chat = document.querySelector('shopify-chat');
    if (chat && chat !== watchedChat) {
      watchedChat = chat;
      apply(chat, hidden);
    }
    if (html.classList.contains('kosz-chat') && hidden) {
      clearTimeout(showTimer);
      showTimer = null;
      hidden = false;
      if (chat) apply(chat, false);
      return;
    }
    if (busy()) {
      clearTimeout(showTimer);
      showTimer = null;
      if (!hidden) {
        hidden = true;
        if (chat) apply(chat, true);
      }
      return;
    }
    if (hidden && !showTimer) {
      showTimer = setTimeout(function () {
        showTimer = null;
        if (busy()) return;
        hidden = false;
        var current = document.querySelector('shopify-chat');
        if (current) apply(current, false);
      }, SHOW_DELAY);
    }
  }

  function start() {
    var classes = new MutationObserver(update);
    classes.observe(html, { attributes: true, attributeFilter: ['class'] });
    classes.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    var pswp = document.querySelector('.pswp');
    if (pswp) classes.observe(pswp, { attributes: true, attributeFilter: ['class'] });
    var dialogs = new MutationObserver(update);
    dialogs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    update();
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
